export default (function (item, user) {
    return "createdBy" in item && item.createdBy && item.createdBy.uuid === user.uuid;
});
